import React, { useState } from 'react';
import { CalendarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';
import { DemoRequestForm } from '../forms/DemoRequestForm';
import { useTranslation } from '../../lib/i18n';
export function DemoRequest() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    lang
  } = useTranslation();
  return <>
      <section className="py-20 bg-dark-surface" data-id="element-217">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-218">
          <div className="w-16 h-16 bg-brand-yellow rounded-industrial flex items-center justify-center mx-auto mb-6" data-id="element-219">
            <CalendarIcon className="w-8 h-8 text-dark-bg" data-id="element-220" />
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-221">
            {lang === 'en' ? <>
                See it <span className="text-brand-yellow" data-id="element-222">in action</span>
              </> : lang === 'ru' ? <>
                Посмотрите <span className="text-brand-yellow" data-id="element-223">в действии</span>
              </> : <>
                Pogledajte <span className="text-brand-yellow" data-id="element-224">u akciji</span>
              </>}
          </h2>
          <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-225">
            {lang === 'en' ? 'Schedule a live demonstration at your location. Experience the power and reliability of D-TECH equipment first-hand.' : lang === 'ru' ? 'Запишитесь на живую демонстрацию на вашей территории. Оцените мощность и надежность оборудования D-TECH лично.' : 'Zakažite demonstraciju uživo na vašoj lokaciji. Iskusite snagu i pouzdanost D-TECH opreme iz prve ruke.'}
          </p>
          <Button variant="primary" size="lg" onClick={() => setIsModalOpen(true)} data-id="element-226">
            {lang === 'en' ? 'Request demonstration' : lang === 'ru' ? 'Запросить демонстрацию' : 'Zatražite demonstraciju'}
          </Button>
          <p className="text-sm text-gray-400 mt-4" data-id="element-227">
            {lang === 'en' ? 'Demo requests must be submitted at least 5 days in advance' : lang === 'ru' ? 'Заявки на демонстрацию должны быть поданы не менее чем за 5 дней' : 'Zahtevi za demonstraciju moraju biti podneseni najmanje 5 dana unapred'}
          </p>
        </div>
      </section>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={lang === 'en' ? 'Request demonstration' : lang === 'ru' ? 'Запросить демонстрацию' : 'Zatražite demonstraciju'} maxWidth="lg" data-id="element-228">
        <DemoRequestForm onSuccess={() => setIsModalOpen(false)} data-id="element-229" />
      </Modal>
    </>;
}